import React from "react"
import autobind from "class-autobind"
import { Table, TableRow, TableBody } from "material-ui"
import { grey500 } from "material-ui/styles/colors"
import { IQuestionTableItem } from "../../models"
interface IProps {
    prefix: string
    questionTableItems: IQuestionTableItem[]
    dragDropRowGroupId: number
    handleDrag(moveUp: number): void
    handleDrop(): void
}
interface IState {
    positionX: number
    positionY: number
    mousePositionX: number
    mousePositionY: number
    isDraging: boolean
}

export default class QuestionDragDropRow extends React.Component<IProps, IState> {
    private initPositionY
    private punchQuestionDocDialogRect = document.getElementsByClassName("PunchQuestionDocDialog")[0].getBoundingClientRect()
    constructor(props: IProps) {
        super(props)
        this.state = {
            positionX: 0,
            positionY: 0,
            mousePositionX: 0,
            mousePositionY: 0,
            isDraging: false,
        }
        autobind(this);
    }

    componentDidMount() {
        this.handleCaptureDragDropRow(this.props)
        window.addEventListener("mousemove", this.handleMouseMoveInWindow)
        window.addEventListener("mouseup", this.handleMouseUpInWindow)
    }

    componentWillReceiveProps(nextProps: IProps) {
        this.props.dragDropRowGroupId !== nextProps.dragDropRowGroupId &&
            this.handleCaptureDragDropRow(nextProps)
    }

    componentWillUnmount() {
        window.removeEventListener("mousemove", this.handleMouseMoveInWindow)
        window.removeEventListener("mouseup", this.handleMouseUpInWindow)
    }

    handleMouseMoveInWindow(e) {
        this.state.isDraging &&
            this.setState({
                positionX: this.state.positionX - (this.state.mousePositionX - e.clientX),
                positionY: this.state.positionY - (this.state.mousePositionY - e.clientY),
                mousePositionX: e.clientX,
                mousePositionY: e.clientY,
            }, () =>
                this.handleDarging()
            )
    }

    handleDarging() {
        const diffRow = Math.round((this.initPositionY - this.state.positionY - this.punchQuestionDocDialogRect.top) / 50)
        if (diffRow === 0) return
        const dragDropItemIndexOf = this.props.questionTableItems.findIndex(item => item.GroupId === this.props.dragDropRowGroupId)
        if (dragDropItemIndexOf === 0 && diffRow > 0) return
        if (dragDropItemIndexOf === this.props.questionTableItems.length - 1 && diffRow < 0) return
        this.initPositionY = this.initPositionY - diffRow * 50
        this.props.handleDrag(diffRow > 0 ? 1 : -1)
    }

    handleMouseUpInWindow() {
        this.state.isDraging &&
            this.props.handleDrop()
    }

    handleCaptureDragDropRow(props: IProps) {
        const questionTableRow = document.getElementById(`${this.props.prefix}_row_${props.dragDropRowGroupId}`)
        const rowRect = questionTableRow.getBoundingClientRect()
        this.initPositionY = rowRect.top
        document.getElementById("DragDropItem").style.width = `${rowRect.width}px`
        this.setState({ positionX: rowRect.left - this.punchQuestionDocDialogRect.left, positionY: rowRect.top - this.punchQuestionDocDialogRect.top })

        const dragDropRow = document.getElementById("OriginalItem")
        dragDropRow.innerHTML = questionTableRow.innerHTML
        document.getElementById("DragDropItemMask").style.width = `${dragDropRow.clientWidth}px`
        document.getElementById("DragDropItemMask").style.height = `${dragDropRow.clientHeight}px`
    }

    render() {
        return (
            <div id="DragDropItem" style={{ position: "fixed", top: this.state.positionY, left: this.state.positionX, zIndex: 1000 }}>
                <div
                    id="DragDropItemMask"
                    style={{ position: "absolute", zIndex: 100, cursor: "move", backgroundColor: grey500, opacity: 0.1 }}
                    onMouseDown={(e) => {
                        e.stopPropagation()
                        if (e.nativeEvent.button === 2) return
                        this.setState({
                            isDraging: true,
                            mousePositionX: e.clientX,
                            mousePositionY: e.clientY
                        })
                    }}
                />
                <Table>
                    <TableBody>
                        <TableRow
                            id="OriginalItem"
                            style={{ border: "1px solid rgb(224, 224, 224)" }}
                        />
                    </TableBody>
                </Table>
            </div>
        )
    }
}